import React from 'react'
import { Link } from '@remix-run/react'

interface ButtonProps {
	path: string
	children: React.ReactNode
	className?: string
}

export function LinkButton({ path = '', children, className = '' }: ButtonProps) {
	return (
		<Link
			to={path}
			className={`rounded-lg bg-neutral-900 px-4 py-2 text-white font-medium hover:bg-neutral-800 focus:outline-none focus:ring-2 focus:ring-neutral-400 focus:ring-offset-1 disabled:opacity-50 dark:bg-blue-600 dark:hover:bg-blue-700 ${className}`}
		>
			{children}
		</Link>
	)
}
